import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { SUCURSAL, SUCURSAL_ORIGEN } from 'Constants'
import { es } from 'date-fns/locale'

export const Fields = (info, handleChange, dataBefore) => {
  return [
    {
      label: 'Origen',
      name: 'empresa',
      options: SUCURSAL_ORIGEN,
      optionLabel: `options["label"]`,
      optionValue: 'id',
      sm: 12,
      xs: 12,
      class: 'autocomplete',
      value: info.empresa,
      onChange: (e) => handleChange('empresa', e.id),
    },
    {
      label: 'Sucursal',
      name: 'sucursal',
      sm: 12,
      xs: 12,
      class: 'autocomplete',
      options: SUCURSAL,
      optionLabel: `options["label"]`,
      optionValue: 'id',
      value: info.sucursal,
      onChange: (e) => handleChange('sucursal', e.id),
    },
    {
      class: 'custom',
      component: (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
          <KeyboardDatePicker
            key="fecha"
            autoOk
            variant="inline"
            inputVariant="outlined"
            PopoverProps={{ style: { ...{ left: '40px' } } }}
            fullWidth
            onChange={(e) => {
              handleChange('fecha', e)
            }}
            disabled={dataBefore.data.permissions.ECO.adminCaja ? false : true}
            name="fecha"
            label="Fecha"
            format="dd/MM/yyyy"
            value={info.fecha}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </MuiPickersUtilsProvider>
      ),
      sm: 12,
      xs: 12,
    },
  ]
}
